import { useQuery } from "@tanstack/react-query";
import { getAnalytics } from "../lib/api/analytics";
import type { AnalyticsReport } from "../lib/api/types";

export function useAnalytics(
  token: string | null,
  schoolProfileId?: string,
  classId?: string,
  timeRange: string = "month",
  filters?: {
    startDate?: string;
    endDate?: string;
    minScore?: number;
    status?: string;
  }
) {
  return useQuery<AnalyticsReport>({
    queryKey: ["analytics", schoolProfileId, classId, timeRange, filters],
    queryFn: () => getAnalytics(token!, schoolProfileId, classId, timeRange, filters),
    enabled: !!token && !!schoolProfileId,
    staleTime: 5 * 60 * 1000,
  });
}
